export const APP_NAME = 'Consumer Portal';
